
import { AppFilter } from "app/models/app-filter.model";
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbConfigVoip extends AppService {

  abstract prefixo: string;
  abstract salvar(configVoip: any): Observable<any>;
  abstract getConfigVoip(): Observable<any>;
  abstract salvarAsync(configVoip: any): any
  abstract getEmProcesso(): Observable<any>
  abstract getLimparStatus(): Observable<any>;
  abstract salvarPorHorario(configVoip: any): Observable<any>;
  abstract getConfigsPorHorario(filter: AppFilter): Observable<any>;
  abstract desativarPorHorario(configVoip: any): Observable<any>;
  abstract desativar(id: number): Observable<any>;
}
